import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../utils/firebase';
import { sendEmailVerification } from 'firebase/auth';
import '../styles/user.css';
import '../styles/auth.css';
import '../styles/buttons.css';


function VerifyEmail() {
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('Please verify your email to continue.');
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        if (user.emailVerified) {
          navigate('/user'); // Redirect to user page if email is verified
        } else {
          // Refresh the user's metadata to check verification status
          user.reload().then(() => {
            if (user.emailVerified) {
              navigate('/user');
            }
          });
        }
      } else {
        navigate('/login'); // Redirect to login if not authenticated
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  const handleResendEmail = async () => {
    try {
      await sendEmailVerification(auth.currentUser);
      setMessage('Verification email resent. Please check your inbox.');
    } catch (error) {
      setError('Failed to resend verification email. Please try again.');
    }
  };

  return (
    <div className="App">
      <div className="verify-email-container">
        <h3>Verify Your Email</h3>
        {message && <p className="info-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}
        <button className="btn-primary" onClick={handleResendEmail}>Resend Verification Email</button>
        <p>
          Already verified?{' '}
          <Link to="/login" className="login-link">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}

export default VerifyEmail;